// A button that asks before it is pressed (FR-EDIT-33).
//
// A button carrying `data-confirm` asks its question first, in the
// browser's own dialog, and does nothing unless the answer is yes: Draft
// from issue on a spec that holds more than the empty scaffold rewrites it
// whole. So does a preset that may ask new questions, Clarify or Draft
// from issue, while an open question holds an answer not yet sent, which
// new questions would close (FR-EDIT-05); Draft from issue asks both in
// one question. The spec chat's Send asks the same, its reply as free to
// ask (FR-EDIT-35), whether clicked or pressed by its key. The click is stopped before the form is sent, so htmx,
// the busy mark and the send-once guard never see it (FR-UI-11). Without
// the bundle the button works as it always did.

import { COMPOSER_SEND, closingQuestion } from "./composer";

/** Ask first for a click on a button that says to; stop it on a no. */
export function askFirst(event: MouseEvent): void {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest<HTMLButtonElement>(
    `button[data-confirm], button[name=preset], ${COMPOSER_SEND}`,
  );
  if (!button || button.disabled) return;
  const question = closingQuestion(button) ?? button.dataset.confirm ?? "";
  if (question !== "" && !window.confirm(question)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}

// Capture, so the question comes before anything else acts on the click.
document.addEventListener("click", askFirst, true);
